import { Helmet } from 'react-helmet';
import BaivietDetail
  from 'src/components/baiviet-detail/BaivietDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import BaivietListToolbar from '../components/baiviet-detail/BaivietToolbar';

const Baiviet = () => (
  <>
    <Helmet>
      <title>Quản lý bài viết</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <BaivietListToolbar />
        <Box sx={{ pt: 3 }}>
          <BaivietDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Baiviet;
